var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-upload-multiple" },
    [
      _vm.itemActivityForm
        ? _c(
            "div",
            { staticClass: "pb8" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.handUpload },
                },
                [_vm._v("上传图片")]
              ),
            ],
            1
          )
        : _c(
            "el-upload",
            {
              ref: "uploader",
              attrs: {
                "auto-upload": _vm.autoUpload,
                disabled: _vm.disabled,
                action: _vm.action,
                name: _vm.name,
                data: _vm.data,
                "http-request": _vm.request,
                "file-list": _vm.defaultFileList,
                "show-file-list": false,
                accept: _vm.accept,
                multiple: _vm.multiple,
                limit: _vm.limit,
                "before-upload": _vm.before,
                "on-remove": _vm.remove,
                "on-success": _vm.success,
                "on-error": _vm.error,
                "on-preview": _vm.handlePreview,
                "on-exceed": _vm.handleExceed,
              },
              scopedSlots: _vm._u([
                {
                  key: "tip",
                  fn: function () {
                    return [
                      _vm.tip
                        ? _c("div", { staticClass: "el-upload__tip" }, [
                            _vm._v(_vm._s(_vm.tip)),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-plus",
                      },
                    },
                    [_vm._v("上传图片")]
                  ),
                ]
              }),
            ],
            2
          ),
      _c(
        "div",
        [
          _c(
            "vxe-table",
            {
              ref: "xTree",
              attrs: {
                border: "",
                data: _vm.defaultFileList,
                "row-config": { useKey: "id", keyField: "id" },
                "edit-config": {
                  trigger: "manual",
                  mode: "row",
                  autoClear: false,
                },
                "max-height": "700px",
              },
            },
            [
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  width: "60",
                  title: "序号",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  width: "120",
                  field: "url",
                  title: "图片",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.url
                          ? [
                              _c(
                                "div",
                                { staticClass: "imageBox" },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        width: "400",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "popoverBox" },
                                        [
                                          _c("el-image", {
                                            staticStyle: { width: "380px" },
                                            attrs: {
                                              src: _vm.setUrlHearder(row.url),
                                              fit: "cover",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("el-image", {
                                        ref: "previewImg_",
                                        staticStyle: {
                                          height: "100px",
                                          width: "100px",
                                          margin: "10px 0",
                                        },
                                        attrs: {
                                          slot: "reference",
                                          src: _vm.setUrlHearder(row.url),
                                          "preview-src-list": [
                                            _vm.setUrlHearder(row.url),
                                          ],
                                        },
                                        on: { click: _vm.handImage },
                                        slot: "reference",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "name",
                  align: "center",
                  "min-width": "200",
                  "edit-render": { placeholder: "请输入" },
                  title: "名称",
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入内容" },
                          on: {
                            input: function ($event) {
                              return _vm.handName(row, rowIndex)
                            },
                          },
                          model: {
                            value: row.name,
                            callback: function ($$v) {
                              _vm.$set(row, "name", $$v)
                            },
                            expression: "row.name",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "fileSize",
                  align: "center",
                  width: "80",
                  title: "大小",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.backSize(row.fileSize))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.setTable
                ? _c("vxe-column", {
                    attrs: {
                      field: "pixel",
                      align: "center",
                      width: "130",
                      title: "像素",
                    },
                  })
                : _vm._e(),
              !_vm.setTable
                ? _c("vxe-column", {
                    attrs: {
                      field: "createDate",
                      align: "center",
                      width: "150",
                      title: "上传时间",
                    },
                  })
                : _vm._e(),
              !_vm.setTable
                ? _c("vxe-column", {
                    attrs: {
                      field: "actorName",
                      align: "center",
                      width: "100",
                      title: "操作人",
                    },
                  })
                : _vm._e(),
              _vm.setTable
                ? _c("vxe-column", {
                    attrs: {
                      sortable: "",
                      field: "description",
                      title: "描述",
                      "edit-render": { placeholder: "请输入" },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "edit",
                          fn: function (ref) {
                            var row = ref.row
                            var rowIndex = ref.rowIndex
                            return [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入描述" },
                                on: {
                                  input: function ($event) {
                                    return _vm.handDescription(row, rowIndex)
                                  },
                                },
                                model: {
                                  value: row.description,
                                  callback: function ($$v) {
                                    _vm.$set(row, "description", $$v)
                                  },
                                  expression: "row.description",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3676827726
                    ),
                  })
                : _vm._e(),
              _c("vxe-column", {
                attrs: {
                  fixed: "right",
                  align: "center",
                  width: "150",
                  title: "操作",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var rowIndex = ref.rowIndex
                      return [
                        _vm.$refs.xTree.isEditByRow(row)
                          ? [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#67c23a" },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-check",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateFileName(row, rowIndex)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "red" },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelRowEvent(row)
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                            ]
                          : [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", icon: "el-icon-edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editRowEvent(row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-delete",
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticStyle: { display: "none !important" } },
        [
          _c("el-input", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
      _c("itemActivityForm", {
        ref: "itemActivityForm",
        attrs: {
          ifDescription: !_vm.setTable,
          ifSetUploadName: _vm.ifSetUploadName,
        },
        on: { doSubmitList: _vm.doSubmitList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }